export interface ReiSiftIntegration {
  id: number;
  account_id: number;
  api_key_id?: number | null;
  rei_sift_account_uuid: string;
  rei_sift_api_key?: string | null;
  created_at: Date;
  created_by: string;
  updated_at?: Date | null;
  updated_by?: string | null;
  predictive_ai?: boolean;
  stacked_niche?: boolean;
  lead_export?: boolean;
  rei_sift_account_name?: string | null;
  rei_sift_owner_name?: string | null;
  rei_sift_owner_email?: string | null;
}

export interface ReiSiftIntegrationSummary {
  status: boolean;
  updated_at?: Date | null;
}

export interface ReisiftIntegrationPayload {
  account_id: number;
  rei_sift_account_uuid?: string;
  is_active?: boolean;
  [ReiSiftIntegrationFeature.PredictiveAi]?: boolean;
  [ReiSiftIntegrationFeature.StackedNiche]?: boolean;
  [ReiSiftIntegrationFeature.LeadExport]?: boolean;
}

export type GetReisiftIntegrationParams = {
  account_id?: number;
};

export enum ReiSiftIntegrationFeature {
  PredictiveAi = "predictive_ai",
  StackedNiche = "stacked_niche",
  LeadExport = "lead_export",
}
